// extracted by mini-css-extract-plugin
export default {"descr":"termsAbout_descr__94mOw","link":"termsAbout_link__tEI81"};